import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el Kit?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. Todo en PDF listo para usar.'
  }, {
    q: '¿Sirve para escuelas técnicas y universidades?',
    a: 'Sí, el contenido está estructurado para adaptarse tanto a nivel secundario técnico como a nivel superior y universitario.'
  }, {
    q: '¿Es editable?',
    a: 'El material viene en formato PDF de alta calidad, listo para imprimir o compartir digitalmente con tus alumnos.'
  }, {
    q: '¿Los 4 bonos están incluidos?',
    a: 'Sí, tanto el Kit Básico como el Pack Pro incluyen los 4 bonos de regalo.'
  }, {
    q: '¿Puedo comprar el básico y actualizar después?',
    a: 'Sí, podés hacerlo, pero recomendamos adquirir el Sistema Pro desde el inicio por el valor agregado de las clases listas.'
  }, {
    q: '¿Funciona para clases presenciales y virtuales?',
    a: 'Totalmente. El material se adapta a ambos formatos de enseñanza sin problemas.'
  }, {
    q: '¿Incluye contenido actualizado sobre normativa forestal?',
    a: 'Sí, todo el contenido está basado en las prácticas y normativas forestales vigentes en Argentina.'
  }, {
    q: '¿Está organizado por nivel de dificultad?',
    a: 'Sí, los temas tienen una progresión lógica, desde conceptos básicos hasta análisis de casos complejos.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, contás con 7 días de garantía de satisfacción total. Si no te sirve, te devolvemos el 100%.'
  }, {
    q: '¿Qué diferencia tiene con material que encuentro en internet?',
    a: 'No son textos sueltos o información sin estructura. Es un sistema pedagógico completo, pensado específicamente para enseñar producción forestal.'
  }];
  return <section className="bg-[#121E19] py-4 md:py-6 px-3 border-b border-[#1F3D2B]" data-id="element-38">
      <div className="max-w-2xl mx-auto" data-id="element-39">
        <h2 className="text-xl md:text-2xl font-black text-white text-center mb-4 uppercase tracking-tight" data-id="element-40">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-1.5" data-id="element-41">
          {faqs.map((faq, i) => <div key={i} className="bg-[#0B1F17] border border-[#1F3D2B] rounded-lg overflow-hidden" data-id="element-42">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-3 text-left hover:bg-[#102A1F] transition-colors" data-id="element-43">
                <span className="font-black text-white text-xs md:text-sm pr-3 leading-tight" data-id="element-44">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-45">
                  <ChevronDown className="w-4 h-4 text-[#D4A843] flex-shrink-0" strokeWidth={3} data-id="element-46" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-47">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden" data-id="element-48">
                    <div className="px-3 pb-3 text-[#BFC9C5] font-bold text-[10px] md:text-xs border-t border-[#1F3D2B] pt-2 bg-[#0B1F17] leading-snug" data-id="element-49">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}